<template>
  <div class="flex gap-2 mb-3">
    <input
      type="date"
      v-model="localStatusDate"
      class="w-1/2 text-xs border border-gray-200 rounded-md px-2 py-1.5 focus:outline-none focus:border-brand-400 focus:ring-0 bg-white"
    />
    <select
      :value="currentStatus"
      class="w-1/2 text-xs border border-gray-200 rounded-md px-2 py-1.5 focus:outline-none focus:border-brand-400 focus:ring-0 bg-white"
      @change="handleStatusChange"
    >
      <option value="">Add Status</option>
      <option v-for="status in statuses" :key="status" :value="status">
        {{ status }}
      </option>
    </select>
  </div>
</template>
  
  <script lang="ts">
  import { ref, watch } from 'vue';

  export default {
    name: 'EditStatus',
    props: {
      currentStatus: String,
      statuses: Array,
      statusDate: String,
    },
    emits: ['update-status'],
    setup(props: { currentStatus?: string; statuses?: string[]; statusDate?: string }, { emit }: { emit: (event: string, ...args: unknown[]) => void }) {
      const localStatusDate = ref<string | undefined>(props.statusDate);

      watch(() => props.statusDate, (newValue: string | undefined) => {
        localStatusDate.value = newValue;
      });

      const updateStatus = (status: string): void => {
        console.log('Updating status:', status, 'on:', localStatusDate.value);
        emit('update-status', status, localStatusDate.value);
      };

      const handleStatusChange = (event: Event): void => {
        updateStatus((event.target as HTMLSelectElement).value);
      };

      return {
        localStatusDate,
        handleStatusChange,
      };
    },
  };
  </script>
